import { render, staticRenderFns } from "./cl-switch.vue?vue&type=template&id=a9284ae0&scoped=true"
import script from "./cl-switch.vue?vue&type=script&lang=js"
export * from "./cl-switch.vue?vue&type=script&lang=js"
import style0 from "./cl-switch.vue?vue&type=style&index=0&id=a9284ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9284ae0",
  null
  
)

export default component.exports